import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setMessage } from '../../store/slices/message'
import CurdTokenervice from '../../services/axios/CurdTokenervice'


export const getQuiz = createAsyncThunk('quizzes/getQuiz', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { token, quizId, courseId, gredId, termId, subjectId } = arg
    try {
        const res = await CurdTokenervice.getQuiz(token, "quiz", quizId, courseId, gredId, termId, subjectId);
        thunkAPI.dispatch(setMessage(res.data.message))
        return res.data
    } catch (error) {
        const message = error.message
        thunkAPI.dispatch(setMessage(message))
        return rejectWithValue(error.message)
    }
})

const quizzesSlice = createSlice({
    name: 'quizzes',
    initialState: { isloading: false, quizzes: [], message: '' },
    reducers: {
        delQuizzes: (state, action) => {
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getQuiz.pending, (state) => {
                state.isloading = true
                state.message = ''
            })
            .addCase(getQuiz.fulfilled, (state, action) => {
                state.isloading = false;
                state.quizzes = action.payload;
                state.message = ''
            })
            .addCase(getQuiz.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })
    },
})

export const { delQuizzes } = quizzesSlice.actions
export default quizzesSlice.reducer